import styled from '@emotion/styled';
import { LazyCardImage } from 'components/common/ui/CardImage';

interface Props {
  url?: string;
  box?: { x?: number; y?: number; width: number; height: number } | null;
}

export const Box = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto;
  min-height: 225px;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const Layers = styled.div<Props>`
  align-self: center;
  display: flex;
  justify-self: center;
  margin: auto;
  position: relative;
  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 30%);

  ${({ box }) =>
    box &&
    `
    width: ${box.width}px;
    height: ${box.height}px;
  `}
`;

export const PhotoLayer = styled.div<Props>`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover !important;
  position: absolute;

  ${({ url }) =>
    url &&
    `
    background: url(${url});
  `}

  ${({ box }) =>
    box &&
    `
    top: ${box.y}px;
    left: ${box.x}px;
    width: ${box.width}px;
    height: ${box.height}px;
  `}
`;

export const TransparentLayer = styled(LazyCardImage)<Props>`
  position: relative;

  ${({ url }) =>
    url &&
    `
    background: url(${url});
  `}

  ${({ box }) =>
    box &&
    `
    width: ${box.width}px;
    height: ${box.height}px;
  `}
`;
